import { render } from "./Scroll.vue?vue&type=template&id=72a42786&scoped=true&ts=true"
import script from "./Scroll.vue?vue&type=script&lang=ts"
export * from "./Scroll.vue?vue&type=script&lang=ts"

import "./Scroll.vue?vue&type=style&index=0&id=72a42786&scoped=true&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a42786"]])

export default __exports__